<template>
    <v-container>
      <vueHeadful
      :title="this.$i18n.t('Menu.GeneralPerfil') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="12" align="center" class="mb-5">
                <h1 class="titulo">{{$t('Menu.GeneralPerfil')}}</h1>
            </v-col>
            <v-col cols="12" align="center" style="margin:30px 0" v-if="usuario.rol === 'artista'">
                <v-btn :to="'/u/' + usuario.nombreDeUsuario" color="primary" class="white--text">{{ $t('Formularios.VerPerfil') }}</v-btn>
            </v-col>
            <v-col cols="12" align="center" v-if="usuario.rol === 'artista' || usuario.rol === 'administrador'">
                <v-avatar size="150">
                    <v-img :src="usuario.fotoPerfil" />
                </v-avatar>
                <br>
                <h3 class="my-5">{{$t('Formularios.FotoPerfil')}}</h3>
            </v-col>
            <v-col cols="12" align="center" v-if="usuario.rol === 'artista'">
              <h2 v-if="usuario.aprobado" class="error--text">{{$t('Formularios.Aprobado')}}</h2>
              <h2 v-if="!usuario.aprobado && !usuario.revision" class="error--text">{{$t('Formularios.NoAprobado')}}</h2>
              <h2 v-if="usuario.revision" class="error--text">{{$t('Formularios.EnRevision')}}</h2>
              <span v-if="!usuario.aprobado && !usuario.revision">{{$t('Formularios.HintNoAprobado')}}</span>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" align="center" v-if="usuario.rol === 'artista'">
                <v-file-input solo v-model="nuevaFoto" :label="$t('Formularios.NuevaFoto')" :hint="$t('Formularios.NuevaFoto')" persistent-hint />
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-text-field solo v-model="usuario.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" persistent-hint />
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-text-field readonly solo v-model="usuario.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint />
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.nombreDeUsuario" :label="$t('Formularios.Usuario')" :hint="$t('Formularios.HintUsuario')" persistent-hint />
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-text-field solo v-model="usuario.telefono" :label="$t('Formularios.Telefono')" :hint="$t('Formularios.Telefono')" persistent-hint />
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-autocomplete solo :items="tiposDocumento" item-text="nombre" item-value="id" v-model="usuario.tipoDocumento" persistent-hint :label="$t('Formularios.TipoDeDocumento')" :hint="$t('Formularios.TipoDeDocumento')"/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-text-field solo v-model="usuario.documento" :label="$t('Formularios.DocumentoIdentificacion')" :hint="$t('Formularios.DocumentoIdentificacion')" persistent-hint required/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-autocomplete solo :items="getPaises" item-text="name" item-value="id" v-model="usuario.pais" :label="$t('Formularios.Pais')" :hint="$t('Formularios.Pais')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.pais">
                <v-autocomplete solo :items="Object.keys(getPaises[usuario.pais - 1].states)" v-model="usuario.departamento" :label="$t('Formularios.Departamento')" :hint="$t('Formularios.Departamento')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.departamento">
              <v-text-field class="mx-2" solo persistent-hint v-model="usuario.ciudad" :label="$t('Formularios.Ciudad')" :hint="$t('Formularios.Ciudad')" />
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-text-field solo v-model="usuario.direccion" :label="$t('Formularios.Direccion')" :hint="$t('Formularios.Nombre')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5">
                <v-text-field solo v-model="usuario.codigoPostal" :label="$t('Formularios.CodigoPostal')" :hint="$t('Formularios.CodigoPostal')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.videoYoutube" :label="$t('Formularios.VideoYoutube')" :hint="$t('Formularios.VideoYoutube')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista'">
                <v-autocomplete solo v-model="usuario.medioDePago" :items="tiposDePago" item-text="nombre" item-value="id" :label="$t('Formularios.MedioDePago')" :hint="$t('Formularios.MedioDePago')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista' && usuario.medioDePago === 'paypal'">
                <v-text-field solo v-model="usuario.paypal" :label="$t('Formularios.Paypal')" :hint="$t('Formularios.Paypal')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista' && usuario.medioDePago === 'banco'">
                <v-file-input solo v-model="certificadoBancario" :label="$t('Formularios.AdjuntarCertificacion')" :hint="$t('Formularios.AdjuntarCertificacion')" @change="subirCertificadoBancario()" :loading="getCargandoAccion" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista'">
              <v-file-input solo v-model="contrato" :label="$t('Formularios.SubirContrato')" @change="subirContrato()" :hint="$t('Formularios.SubirContrato')" :loading="getLoading" persistent-hint/>
            </v-col>
            <v-col cols="12" align="center" class="my-5" v-if="usuario.rol === 'artista'">
              <v-btn color="black white--text" x-large @click="descargarContrato()">{{$t('Formularios.DescargarContrato')}}</v-btn>
            </v-col>
            <v-col cols="12" align="center" v-if="usuario.contratoSubido">
              <h2 v-if="usuario.aprobado">{{$t('Formularios.ContratoAprobado')}}</h2>
              <h2 v-else>{{$t('Formularios.ContratoSubido')}}</h2>
            </v-col>
            <v-col cols="12" class="my-5" v-if="usuario.rol === 'artista'">
                <v-textarea solo v-model="usuario.biografiaEs" :label="$t('Formularios.BiografiaEs')" :hint="$t('Formularios.BiografiaEs')" persistent-hint/>
            </v-col>
            <v-col cols="12" class="my-5" v-if="usuario.rol === 'artista'">
                <v-textarea solo v-model="usuario.biografiaEn" :label="$t('Formularios.BiografiaEn')" :hint="$t('Formularios.BiografiaEn')" persistent-hint/>
            </v-col>
            <!-- REFERENCIAS PERSONALES -->
            <v-col cols="12" align="center" v-if="usuario.rol === 'artista'">
                 <h2 style="word-break:break-word;">{{$t('Menu.ReferenciaPersonal')}}</h2>
            </v-col>
            <!-- NOMBRE REF PERSONAL -->
            <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.nombreRefPersonal" :label="$t('Formularios.NombreCompleto')" :hint="$t('Formularios.NombreCompleto')" persistent-hint/>
            </v-col>
            <!-- Email REF PERSONAL -->
            <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.emailRefPersonal" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint/>
            </v-col>
            <!-- TELEFONO REF PERSONAL -->
            <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.telefonoRefPersonal" :label="$t('Formularios.TelefonoIndicativo')" :hint="$t('Formularios.TelefonoIndicativo')" persistent-hint/>
            </v-col>
             <!-- REFERENCIAS PROFESIONALES-->
            <v-col cols="12" align="center" v-if="usuario.rol === 'artista'">
                 <h2 style="word-break:break-word;">{{$t('Menu.ReferenciaProfesional')}}</h2>
            </v-col>
            <!-- NOMBRE REF PROFESIONAL -->
            <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.nombreRefProfesional" :label="$t('Formularios.NombreCompleto')" :hint="$t('Formularios.NombreCompleto')" persistent-hint/>
            </v-col>
            <!-- Email REF PROFESIONAL -->
            <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.emailRefProfesional" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint/>
            </v-col>
            <!-- TELEFONO REF PROFESIONAL -->
            <v-col cols="12" xs="12" md="4" class="my-5" v-if="usuario.rol === 'artista'">
                <v-text-field solo v-model="usuario.telefonoRefProfesional" :label="$t('Formularios.TelefonoIndicativo')" :hint="$t('Formularios.TelefonoIndicativo')" persistent-hint/>
            </v-col>
            <!-- <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista'">
            <v-autocomplete solo :items="getTipoRedes" item-text="nombre" item-value="icono" v-model="iconoRed" :label="$t('Formularios.RedSocial')" :hint="$t('Formularios.RedSocial')" persistent-hint/>
            </v-col>
            <v-col cols="12" xs="12" md="6" class="my-5" v-if="usuario.rol === 'artista'">
            <v-text-field solo v-model="enlaceRed" :label="$t('Formularios.EnlaceRedSocial')" :hint="$t('Formularios.EnlaceRedSocial')" v-on:keyup.enter="anadirRed" persistent-hint/>
            </v-col> -->
            <!-- <v-col cols="12" class="my-5" v-if="usuario.rol === 'artista'" align="center">
            <v-btn color="black white--text" x-large style="min-width:20%!important" @click="anadirRed">{{ $t('Formularios.AnadirRedSocial') }}</v-btn>
            </v-col> -->
            <!-- <v-col cols="12" class="my-5" v-if="usuario.rol === 'artista'">
                <v-simple-table>
                    <thead>
                    <tr>
                        <th class="text-center">{{ $t('Formularios.Red') }}</th>
                        <th class="text-center">{{ $t('Formularios.Enlace') }}</th>
                        <th class="text-center">{{ $t('Formularios.Eliminar') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(i, index) in usuario.redesSociales" :key="i.enlace">
                        <td class="text-center"><v-icon>{{i.icono}}</v-icon></td>
                        <td class="text-center">{{i.enlace}}</td>
                        <td class="text-center"><v-btn text small @click="eliminarRed(index)"><v-icon>fas fa-times</v-icon></v-btn></td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-col> -->
            <v-col cols="12" class="mt-5" v-if="usuario.rol === 'artista'">
                <v-row>
                    <v-col cols="3" v-for="(i, index) in usuario.imagenes" :key="index" align="center">
                        <v-img :src="i" max-height="250px" contain />
                        <v-btn @click="eliminarImagen(index)" outlined class="mt-3">{{ $t('Formularios.Eliminar') }}</v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="mb-5">
                <v-checkbox v-model="usuario.newsletter" :label="$t('Formularios.Newsletter')" :hint="$t('Formularios.Newsletter')" color="primary"/>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn v-if="getRol === 'artista'" class="ma-3" color="black white--text" x-large style="min-width:20%!important" @click="guardarUsuario" :loading="getCargandoAccion">{{ $t('Formularios.GuardarSinEnviar') }}</v-btn>
              <v-btn v-if="getRol === 'artista'" class="ma-3" color="black white--text" x-large style="min-width:20%!important" @click="actualizarUsuario" :loading="getCargandoAccion">{{ $t('Formularios.EnviarAprobacion') }}</v-btn>
              <v-btn v-else class="ma-3" color="black white--text" x-large style="min-width:20%!important" @click="actualizarUsuario" :loading="getCargandoAccion">{{ $t('Formularios.Actualizar') }}</v-btn>
            </v-col>
            <v-col cols="12" align="center" style="margin-top:50px">
            <v-btn @click="dialogEliminar = true" text color="black" class="my-5">{{$t('Formularios.EliminarPerfil')}}</v-btn>
            </v-col>
            <v-dialog v-model="dialogEliminar">
              <v-card>
                <v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12" align="center">
                        <h1>{{$t('Formularios.TituloEliminar')}}</h1>
                      </v-col>
                      <v-col cols="12" align="center">
                        <p style="word-break:break-word;">{{$t('Formularios.MensajeEliminar')}}</p>
                      </v-col>
                      <v-col cols="12" align="center">
                        <v-btn class="ma-3" x-large outlined style="border: 2px solid;" @click="dialogEliminar = false">{{$t('Formularios.Cerrar')}}</v-btn>
                        <v-btn class="ma-3" x-large color="red white--text" @click="eliminarPerfil()">{{$t('Formularios.EliminarPerfil')}}</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>
              </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as firebase from 'firebase/app'
import * as faker from 'faker'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
export default {
  name: 'General',
  data () {
    return {
      postulaciones: [],
      dialogEliminar: false,
      productos: [],
      submenu: 'general',
      nuevaFoto: null,
      usuario: [],
      iconoRed: null,
      enlaceRed: null,
      certificadoBancario: null,
      contrato: null,
      tiposDocumento: [
        {
          id: 'CC',
          nombre: this.$i18n.t('Formularios.CedulaCiudadania')
        },
        {
          id: 'TI',
          nombre: this.$i18n.t('Formularios.TarjetaIdentidad')
        },
        {
          id: 'CE',
          nombre: this.$i18n.t('Formularios.CedulaExtranjeria')
        }
      ],
      tiposDePago: [
        {
          id: 'banco',
          nombre: this.$i18n.t('Formularios.ConsignacionBancaria')
        },
        {
          id: 'paypal',
          nombre: this.$i18n.t('Formularios.Paypal')
        }
      ],
      imagenes: null
    }
  },
  computed: {
    ...mapGetters(['getUsuario', 'getPaises', 'getTipoRedes', 'getCargandoAccion', 'getIdioma', 'getRol', 'getLoading'])
  },
  methods: {
    ...mapMutations(['setCargandoAccion', 'setAlerta', 'setTextoAlerta', 'setLoading']),
    ...mapActions(['eliminarUsuario', 'enviarCorreo', 'eliminarDataUsuario']),
    async actualizarUsuario () {
      this.setCargandoAccion(true)
      if (this.getRol === 'artista') {
        this.usuario.aprobado = false
        this.usuario.revision = true
      }
      if (this.getUsuario.nombreDeUsuario !== this.usuario.nombreDeUsuario) {
        var nombresDeUsuario = null
        firebase.firestore().collection('utilidades').doc('nombresDeUsuario').get().then(info => {
          nombresDeUsuario = info.data().nombresDeUsuario
          var cont = nombresDeUsuario.length
          for (let i = 0; i < this.nombresDeUsuario.length; i++) {
            if (this.nombresDeUsuario[i] === this.infoArtista.nombreDeUsuario) {
              this.setAlerta()
              this.setTextoAlerta('Alerta.NombreEnUso')
              break
            }
            cont = cont - 1
            if (cont === 0) {
              this.finalizarActualizacion()
            }
          }
        })
      } else {
        this.finalizarActualizacion()
      }
    },
    async guardarUsuario () {
      this.setCargandoAccion(true)
      this.usuario.aprobado = false
      this.usuario.revision = false
      if (this.getUsuario.nombreDeUsuario !== this.usuario.nombreDeUsuario) {
        var nombresDeUsuario = null
        firebase.firestore().collection('utilidades').doc('nombresDeUsuario').get().then(info => {
          nombresDeUsuario = info.data().nombresDeUsuario
          var cont = nombresDeUsuario.length
          for (let i = 0; i < this.nombresDeUsuario.length; i++) {
            if (this.nombresDeUsuario[i] === this.infoArtista.nombreDeUsuario) {
              this.setAlerta()
              this.setTextoAlerta('Alerta.NombreEnUso')
              break
            }
            cont = cont - 1
            if (cont === 0) {
              this.finalizarGuardado()
            }
          }
        })
      } else {
        this.finalizarGuardado()
      }
    },
    async finalizarActualizacion () {
      if (this.nuevaFoto) {
        let upload = await firebase.storage().ref().child('/usuarios/' + this.usuario.uid + '/' + this.nuevaFoto.name).put(this.nuevaFoto)
        let url = await upload.ref.getDownloadURL()
        this.usuario.fotoPerfil = url
      }
      if (this.imagenes) {
        for (let i = 0; i < this.imagenes.length; i++) {
          let upload = await firebase.storage().ref().child('/usuarios/' + this.usuario.uid + '/' + this.imagenes[i].name).put(this.imagenes[i])
          let url = await upload.ref.getDownloadURL()
          this.usuario.imagenes.push(url)
        }
      }
      firebase.firestore().collection('usuarios').doc(this.usuario.uid).update(this.usuario).then(() => {
        this.setCargandoAccion(false)
        this.setAlerta()
        this.setTextoAlerta('Alerta.UsuarioActualizado')
        this.enviarCorreo({
          destino: 'soycliente@trartist.com',
          asunto: this.$i18n.t('Formularios.ActualizacionPerfil', { nombre: this.getUsuario.nombre }),
          texto: this.$i18n.t('Formularios.TextoActualizacionPerfil', { nombre: this.getUsuario.nombre })
        })
      }).catch(error => {
        this.setCargandoAccion(false)
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    },
    async finalizarGuardado () {
      if (this.nuevaFoto) {
        let upload = await firebase.storage().ref().child('/usuarios/' + this.usuario.uid + '/' + this.nuevaFoto.name).put(this.nuevaFoto)
        let url = await upload.ref.getDownloadURL()
        this.usuario.fotoPerfil = url
      }
      if (this.imagenes) {
        for (let i = 0; i < this.imagenes.length; i++) {
          let upload = await firebase.storage().ref().child('/usuarios/' + this.usuario.uid + '/' + this.imagenes[i].name).put(this.imagenes[i])
          let url = await upload.ref.getDownloadURL()
          this.usuario.imagenes.push(url)
        }
      }
      firebase.firestore().collection('usuarios').doc(this.usuario.uid).update(this.usuario).then(() => {
        this.setCargandoAccion(false)
        this.setAlerta()
        this.setTextoAlerta('Alerta.UsuarioActualizado')
      }).catch(error => {
        this.setCargandoAccion(false)
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    },
    anadirRed () {
      if (this.usuario.redesSociales.length <= 1) {
        var red = {
          icono: this.iconoRed,
          enlace: this.enlaceRed
        }
        this.usuario.redesSociales.push(red)
        this.iconoRed = null
        this.enlaceRed = null
      }
    },
    eliminarRed (index) {
      this.info.redesSociales.splice(index, 1)
    },
    eliminarImagen (index) {
      this.usuario.imagenes.splice(index, 1)
      firebase.firestore().collection('usuarios').doc(this.usuario.uid).update(this.usuario).then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.UsuarioActualizado')
      })
    },
    descargarContrato () {
      firebase.firestore().collection('utilidades').doc('contrato').get().then(info => {
        if (this.getIdioma === 'es') {
          window.open(info.data().contratoEs, '_blank')
        }
        if (this.getIdioma === 'en') {
          window.open(info.data().contratoEn, '_blank')
        }
      })
    },
    async subirContrato () {
      try {
        this.setLoading(true)
        const url = await this.subirDocumento()
        if (url) {
          console.log('subirContrato url', url)
          firebase.firestore().collection('contratos').doc(this.usuario.uid).set({
            uid: this.usuario.uid,
            nombre: this.usuario.nombre,
            documento: this.usuario.documento,
            tipoDocumento: this.usuario.tipoDocumento,
            pais: this.getPaises[this.usuario.pais - 1].name,
            departamento: this.usuario.departamento,
            ciudad: this.usuario.ciudad,
            urlContrato: url,
            email: this.usuario.email,
            aprobado: false,
            revisado: false
          })
            .then(() => {
              firebase.firestore().collection('usuarios').doc(this.usuario.uid).update({
                aprobado: false,
                revision: true,
                contratoSubido: true
              }).then(() => {
                this.setAlerta()
                this.setTextoAlerta('Alerta.InformacionActualizada')
                this.setLoading(false)
              }).catch((error) => {
                console.log('subirContrato error', error)
                this.setLoading(false)
              })
            }).catch((error) => {
              console.log('subirContrato error', error)
              this.setLoading(false)
            }).catch((error) => {
              console.log('subirContrato error', error)
            })
        } else {
          this.setLoading(false)
          console.log('subirContrato url', url)
        }
      } catch (error) {
        this.setLoading(false)
        console.log('subirContrato error', error)
      }
    },
    async subirDocumento () {
      if (this.contrato) {
        var upload = await firebase.storage().ref().child('contratos/' + this.usuario.uid).put(this.contrato)
        var url = await upload.ref.getDownloadURL()
        return url
      } else {
        return ''
      }
    },
    async subirCertificadoBancario () {
      try {
        this.setCargandoAccion(true)
        const url = await this.subirCertificado()
        if (url) {
          console.log('subirCertificadoBancario url', url)
          firebase.firestore().collection('certificados_bancarios').doc(this.usuario.uid).set({
            uid: this.usuario.uid,
            nombre: this.usuario.nombre,
            documento: this.usuario.documento,
            tipoDocumento: this.usuario.tipoDocumento,
            pais: this.getPaises[this.usuario.pais - 1].name,
            departamento: this.usuario.departamento,
            ciudad: this.usuario.ciudad,
            telefono: this.usuario.telefono,
            urlCertificado_bancario: url,
            email: this.usuario.email,
            aprobado: false,
            revisado: false
          })
            .then(() => {
              firebase.firestore().collection('usuarios').doc(this.usuario.uid).update({
                aprobado: false,
                revision: true,
                certificadoBancarioSubido: true
              }).then(() => {
                this.setAlerta()
                this.setTextoAlerta('Alerta.InformacionActualizada')
                this.setCargandoAccion(false)
              }).catch((error) => {
                console.log('subirCertificadoBancario error', error)
                this.setCargandoAccion(false)
              })
            }).catch((error) => {
              console.log('subirCertificadoBancario error', error)
              this.setCargandoAccion(false)
            }).catch((error) => {
              console.log('subirCertificadoBancario error', error)
            })
        } else {
          this.setCargandoAccion(false)
          console.log('subirCertificadoBancario url', url)
        }
      } catch (error) {
        this.setCargandoAccion(false)
        console.log('subirCertificadoBancario', error)
      }
    },
    async subirCertificado () {
      if (this.certificadoBancario) {
        var upload = await firebase.storage().ref().child('certificados_bancarios/' + this.usuario.uid).put(this.certificadoBancario)
        var url = await upload.ref.getDownloadURL()
        return url
      } else {
        return ''
      }
    },
    async eliminarProductos () {
      for (var i = 0; i < this.productos.length; i++) {
        await firebase.firestore().collection('productos').doc(this.productos[i].uid).delete().then(() => {
        }).catch((error) => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
      }
    },
    async eliminarStorageProductos () {
      for (var i = 0; i < this.productos.length; i++) {
        await firebase.storage().ref('productos').child(this.productos[i].uid).listAll().then(files => {
          for (let i = 0; i < files.items.length; i++) {
            firebase.storage().ref().child(files.items[i].fullPath).delete()
          }
        }).catch((error) => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
      }
    },
    async eliminarUsuario () {
      await firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).delete().then(() => {
        // console.log('usuario Eliminado')
      }).catch((error) => {
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    },
    async createUserDeleted () {
      if (this.getUsuario.rol === 'cliente') {
        var user = {
          // INFO
          uid: faker.random.alphaNumeric(8),
          nombre: this.getUsuario.nombre,
          rol: this.getUsuario.rol,
          email: this.getUsuario.email
        }
        await firebase.firestore().collection('deleted_users').doc(user.uid).set(user).then(() => {
          // console.log('usuario inhabilitado agregado')
        }).catch((error) => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
      } else {
        var userArtista = {
        // INFO
          uid: faker.random.alphaNumeric(8),
          nombre: this.getUsuario.nombre,
          rol: this.getUsuario.rol,
          tipoDocumento: this.getUsuario.tipoDocumento,
          pais: this.getUsuario.pais,
          numeroDocumento: this.getUsuario.numeroDocumento,
          departamento: this.getUsuario.departamento,
          ciudad: this.getUsuario.ciudad,
          email: this.getUsuario.email
        }
        await firebase.firestore().collection('deleted_users').doc(userArtista.uid).set(userArtista).then(() => {
          // console.log('usuario inhabilitado agregado')
        }).catch((error) => {
          this.setAlerta()
          this.setTextoAlerta(error)
        })
      }
    },
    async updateUsuario () {
      // firebase.firestore().collection('productos').where('artista.uid', '==', this.getUsuario.uid).get().then(info => {
      // })
      await firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
        disabled: true
      }).then(() => {
        // console.log('usuario inhabilitado')
      }).catch((error) => {
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    },
    async eliminarDataPerfil () {
      // firebase.firestore().collection('productos').where('artista.uid', '==', this.getUsuario.uid).get().then(info => {
      // })
      await firebase.auth().currentUser.delete().then(() => {
        this.setAlerta()
        this.setTextoAlerta('Alerta.PerfilEliminado')
        // this.$router.push('/')
      }).catch((error) => {
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    },
    async updatePostulaciones () {
      await firebase.firestore().collection('postulaciones').where('email', '==', this.getUsuario.email).get().then(info => {
        for (let i = 0; i < info.docs.length; i++) {
          this.postulaciones.push(info.docs[i].data())
          firebase.firestore().collection('postulaciones').doc(this.postulaciones[0].codigo).update({
            aprobado: false
          }).then(() => {
            // console.log('postulacion actualizada')
          }).catch((error) => {
            this.setAlerta()
            this.setTextoAlerta(error)
          })
        }
      }).catch((error) => {
        this.setAlerta()
        this.setTextoAlerta(error)
      })
    },
    async eliminarPerfil () {
      try {
        await this.eliminarProductos()
        await this.updatePostulaciones()
        await this.eliminarStorageProductos()
        await this.createUserDeleted()
        await this.eliminarUsuario()
        await this.eliminarDataPerfil()
        setTimeout(() => location.reload(), 2000)
        setTimeout(() => this.setTextoAlerta('Alerta.PerfilEliminado'), 2000)
      } catch (error) {
        this.setAlerta()
        this.setTextoAlerta(error)
      }
    }
  },
  async mounted () {
    // var user = firebase.auth().currentUser;
    this.usuario = this.getUsuario
    if (!this.usuario.telefonoRefPersonal) {
      this.usuario.telefonoRefPersonal = '+'
    }
    if (!this.usuario.telefonoRefProfesional) {
      this.usuario.telefonoRefProfesional = '+'
    }
    if (this.usuario.fotoPerfil === '') {
      this.usuario.fotoPerfil = 'https://firebasestorage.googleapis.com/v0/b/trartist-com.appspot.com/o/utilidades%2FFotoPerfil.jpg?alt=media&token=73608a3e-4d34-429a-a618-7bf392ac858f'
    }
    firebase.firestore().collection('productos').where('artista.uid', '==', this.getUsuario.uid).get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.productos.push(info.docs[i].data())
      }
    })
    // console.log('productos', this.productos)
  }
}
</script>
